const hotelMeetingRooms = {
  props: {
    meetingRoomCmpSelector: ".JS-meeting-rooms",
    facetSelector: ".meeting-facet",
    meetingCardSelector: ".JS-meeting-card",
    cleanFilterBtnSelector: ".delete-filters-btn",
    numberGroupInputSelector: ".number-group-input",
    numberGroupInputSelectorPlus: "number-group-input__plus",
    emptyMessageSelector: "JS-meeting-empty-message",
    dataRoom: null,
    hidden: "hidden",
    limit: 50,
    roomLayoutSelector: ".JS-room-layout",
    filters: {
      rangeFilter: {
        containerSelector: ".JS-range-slider",
        rangeFillSelector: ".JS-range-fill",
        inputNumbersSelectors: {
          min: "JS-number-min",
          max: "JS-number-max",
        },
        inputRangeSelectors: {
          min: "JS-range-min",
          max: "JS-range-max",
        },
      },
      inputMaxPax: 1001,
      inputMinPax: 1,
      currentPaxMax: 1001,
      currentPaxMin: 1,
      selectedFilters: [],
      capacities: {
        capacity1: { min: 1, max: 150 },
        capacity2: { min: 151, max: 300 },
        capacity3: { min: 301, max: 600 },
        capacity4: { min: 601, max: 1000 },
        capacity5: { min: 1001, max: Infinity },
      },
      capacityFilter: "maxPax",
    },
  },
  init: function () {
    const meetingRoomsCmp = document.querySelectorAll(this.props.meetingRoomCmpSelector);
    meetingRoomsCmp?.forEach((cmp) => {
      if (cmp.dataset && cmp.dataset.filters) {
        this.props.dataRoom = JSON.parse(cmp.dataset.filters);
        this.initFacets(cmp);
      }
    });
  },
  initFacets: function (cmp) {
    const facets = cmp.querySelectorAll(this.props.facetSelector);
    const cards = cmp.querySelectorAll(this.props.meetingCardSelector);
    if (facets && cards) {
      this.initCleanFilterBtn(cmp, cards, facets);
      facets.forEach((facet) => {
        const rangeFilterCont = facet.querySelector(this.props.filters.rangeFilter.containerSelector);
        if (rangeFilterCont) {
          this.initRangeListener(rangeFilterCont, cards, cmp);
        }
        facet.querySelector("input[type='checkbox']")?.addEventListener("click", (e) => {
          this.setCheckFilters(e.target, cards, facet, cmp);
        });
      });
    }
  },
  isMaxInput: function (input) {
    return input?.classList?.contains(this.props.filters.rangeFilter.inputNumbersSelectors.max) || input?.classList?.contains(this.props.filters.rangeFilter.inputRangeSelectors.max);
  },
  isMinInput: function (input) {
    return input?.classList?.contains(this.props.filters.rangeFilter.inputNumbersSelectors.min) || input?.classList?.contains(this.props.filters.rangeFilter.inputRangeSelectors.min);
  },
  initRangeListener: function (rangeFilterCont, cards, cmp) {
    rangeFilterCont.addEventListener("change", (e) => {
      if (e.target.nodeName == "INPUT") {
        this.setRangeFilter(cards, cmp);
      }
    });
    rangeFilterCont.addEventListener("input", (e) => {
      if (e.target.nodeName == "INPUT") {
        this.changeCapacityInputValue(rangeFilterCont, e.target);
      }
    });
  },
  setMaxCapacityInputValues: function (rangeFilterCont, input) {
    const numberMaxInput = rangeFilterCont.querySelector("." + this.props.filters.rangeFilter.inputNumbersSelectors.max);
    if (input.value && input.value <= this.props.filters.inputMaxPax && numberMaxInput) {
      if (parseInt(input.value) <= this.props.filters.currentPaxMin + this.props.limit) {
        input.value = this.props.filters.currentPaxMin + this.props.limit;
      }
      if (input.type == "number") {
        rangeFilterCont.querySelector("." + this.props.filters.rangeFilter.inputRangeSelectors.max).value = input.value;
      } else {
        numberMaxInput.value = input.value;
      }
      this.changeTooltipPosition(numberMaxInput, input, null);
      this.changeRangeFillPosition(rangeFilterCont, input, null);
      this.props.filters.currentPaxMax = parseInt(input.value);
      this.togglePlusSymbol(numberMaxInput);
    }
  },
  setMinCapacityInputValues: function (rangeFilterCont, input) {
    const numberMinInput = rangeFilterCont.querySelector("." + this.props.filters.rangeFilter.inputNumbersSelectors.min);
    if (input.value && input.value >= this.props.filters.inputMinPax && numberMinInput) {
      if (parseInt(input.value) >= this.props.filters.currentPaxMax - this.props.limit) {
        input.value = this.props.filters.currentPaxMax - this.props.limit;
      }
      if (input.type == "number") {
        rangeFilterCont.querySelector("." + this.props.filters.rangeFilter.inputRangeSelectors.min).value = input.value;
      } else {
        numberMinInput.value = input.value;
      }
      this.changeTooltipPosition(numberMinInput, input, true);
      this.changeRangeFillPosition(rangeFilterCont, input, true);
      this.props.filters.currentPaxMin = parseInt(input.value);
    }
  },
  changeCapacityInputValue: function (rangeFilterCont, input) {
    if (input.value != null && input.value != "") {
      if (this.isMaxInput(input)) {
        this.setMaxCapacityInputValues(rangeFilterCont, input);
      }
      if (this.isMinInput(input)) {
        this.setMinCapacityInputValues(rangeFilterCont, input);
      }
    }
  },
  changeRangeFillPosition: function (rangeFilterCont, currentInput, left) {
    const rangeSliderFill = rangeFilterCont.querySelector(this.props.filters.rangeFilter.rangeFillSelector);
    if (rangeSliderFill && currentInput) {
      const positionNumber = Number(((currentInput.value - currentInput.min) * 100) / (currentInput.max - currentInput.min));
      if (left) {
        rangeSliderFill.style.left = positionNumber + "%";
      } else {
        rangeSliderFill.style.right = 100 - positionNumber + "%";
      }
    }
  },
  changeTooltipPosition: function (numberInput, currentInput, left) {
    if (numberInput && currentInput) {
      const positionNumber = Number(((currentInput.value - currentInput.min) * 100) / (currentInput.max - currentInput.min));
      const numberGroup = numberInput.closest(this.props.numberGroupInputSelector);
      if (numberGroup) {
        if (left) {
          numberGroup.style.left = `calc(${positionNumber}% + (${-(numberGroup.getBoundingClientRect().width / 2 + (positionNumber > 0 ? positionNumber / 10 : 0))}px))`;
        } else {
          numberGroup.style.left = `calc(${positionNumber}% + (${-(numberGroup.getBoundingClientRect().width / 2 + positionNumber / 10)}px))`;
        }
      }
    }
  },
  setRangeFilter: function (cards, cmp) {
    if (!this.props.filters.selectedFilters.includes(this.props.filters.capacityFilter)) {
      this.props.filters.selectedFilters.push(this.props.filters.capacityFilter);
    }
    this.filterRooms(cards, cmp);
  },
  initCleanFilterBtn: function (cmp, cards, facets) {
    const cleanFilterBtn = cmp.querySelector(this.props.cleanFilterBtnSelector + " .c-cta");
    if (cleanFilterBtn) {
      cleanFilterBtn.addEventListener("click", () => this.cleanFilter(cards, facets, cmp));
    }
  },
  setCheckFilters: function (input, cards, facet, cmp) {
    if (input.checked) {
      this.props.filters.selectedFilters.push(facet.dataset.facet);
    } else {
      this.props.filters.selectedFilters = this.props.filters.selectedFilters.filter((el) => el != facet.dataset.facet);
    }
    this.filterRooms(cards, cmp);
  },
  filterRooms: function (cards, cmp) {
    if (!cards) {
      return;
    }
    const selectedFilters = this.props.filters.selectedFilters;
    if (selectedFilters.length > 0) {
      cards.forEach((card) => {
        const roomObject = this.getObjectValuesByKey(card.dataset?.roomName);
        if (roomObject) {
          const arrayFilters = Object.keys(roomObject)?.filter((key) => roomObject[key] !== false);
          if (arrayFilters) {
            selectedFilters.every((value) => this.check(value, arrayFilters, roomObject)) ? this.showCard(card) : this.hideCard(card);
          }
        }
      });
    } else {
      cards.forEach((card) => {
        this.showCard(card);
      });
    }
    const $emptyMessage = cmp.querySelector("." + this.props.emptyMessageSelector);
    if ($emptyMessage) {
      $emptyMessage.classList.toggle(this.props.hidden, !this.showOrHideEmptyMessage(cards));
    }
  },
  showOrHideEmptyMessage: function (cards) {
    return cards.length == Array.from(cards).filter((card) => card.classList.contains(this.props.hidden))?.length;
  },
  check: function (value, arrayFilters, roomObject) {
    if (value == this.props.filters.capacityFilter) {
      return this.numberBetween(roomObject);
    }
    return arrayFilters.includes(value);
  },
  toggleActiveLayout: function (card) {
    if (this.props.filters.selectedFilters != null) {
      const cardLayouts = card.querySelectorAll(this.props.roomLayoutSelector);
      cardLayouts?.forEach((el) => {
        el.classList.toggle("mod--active", this.props.filters.selectedFilters.includes(el.dataset.layout));
      });
    }
  },
  showCard: function (card) {
    this.toggleActiveLayout(card);
    card?.classList?.remove(this.props.hidden);
  },
  hideCard: function (card) {
    this.toggleActiveLayout(card);
    card?.classList?.add(this.props.hidden);
  },
  cleanFilter: function (cards, facets, cmp) {
    this.props.filters.selectedFilters = [];
    cards.forEach((card) => this.showCard(card));
    facets.forEach((facet) => {
      if (facet.querySelector("input[type='checkbox']")) {
        facet.querySelector("input[type='checkbox']").checked = false;
      }
      if (facet.querySelector(this.props.filters.rangeFilter.containerSelector)) {
        this.clearCapacityInputs(facet);
      }
    });
    const $emptyMessage = cmp.querySelector("." + this.props.emptyMessageSelector);
    if ($emptyMessage) {
      $emptyMessage.classList.add(this.props.hidden);
    }
  },
  clearCapacityInputs: function (facet) {
    const rangeInputs = facet.querySelectorAll("input[type='range']"),
      numberInputs = facet.querySelectorAll("input[type='number']");
    rangeInputs?.forEach((input) => {
      this.toDefaultValues(facet, input, this.props.filters.rangeFilter.inputRangeSelectors.min);
    });
    numberInputs?.forEach((input) => {
      this.toDefaultValues(facet, input, this.props.filters.rangeFilter.inputNumbersSelectors.min);
    });
  },
  toDefaultValues: function (facet, input, minClass) {
    if (input.classList.contains(minClass)) {
      input.value = this.props.filters.inputMinPax;
    } else {
      input.value = this.props.filters.inputMaxPax;
    }
    this.changeCapacityInputValue(facet, input);
  },
  getObjectValuesByKey: function (keyName) {
    const obj = this.props.dataRoom?.find((obj) => obj[keyName]);
    if (obj) {
      return Object.values(obj)[0];
    }
  },
  numberBetween: function (roomObject) {
    const capacity = Object.keys(roomObject)?.filter((key) => key.startsWith("capacity") && roomObject[key] !== false);
    const values = this.props.filters.capacities[capacity];
    return values ? values.max >= this.props.filters.currentPaxMin && values.min <= this.props.filters.currentPaxMax : true;
  },
  togglePlusSymbol: function (numberMaxInput) {
    const numberGrupInput = numberMaxInput.closest(this.props.numberGroupInputSelector);
    if (numberGrupInput) {
      if (this.props.filters.currentPaxMax == this.props.filters.inputMaxPax) {
        numberGrupInput.classList.add(this.props.numberGroupInputSelectorPlus);
      } else if (numberGrupInput.classList.contains(this.props.numberGroupInputSelectorPlus)) {
        numberGrupInput.classList.remove(this.props.numberGroupInputSelectorPlus);
      }
    }
  },
};
export default hotelMeetingRooms;
